export type Lang = 'nb' | 'en'

export type LocaleString = { nb?: string | null; en?: string | null }

export type LocaleText = { nb?: string | null; en?: string | null }

export type LoadedTranslations = Record<string, { nb: string | null; en: string | null }>

export const TRANSLATION_NAMESPACES = [
  'common',
  'home',
  'tasks',
  'carPark',
  'archive',
  'reports',
  'employeeList',
  'company',
] as const

export type TranslationNamespace = (typeof TRANSLATION_NAMESPACES)[number]

export const DEFAULT_LANG: Lang = 'nb'

export const detectLang = (): Lang =>
  typeof navigator !== 'undefined' && navigator.language.startsWith('en') ? 'en' : 'nb'

export const toLang = (language?: string | null): Lang => {
  if (!language) return detectLang()
  return language.toLowerCase().startsWith('en') ? 'en' : 'nb'
}

export const toLocaleCode = (lang: Lang): string => (lang === 'en' ? 'en-GB' : 'nb-NO')

export const localize = (value: LocaleString | null | undefined, lang: Lang): string =>
  value?.[lang] ?? value?.nb ?? value?.en ?? ''
